import { cn } from "@/lib/utils";

interface ProgressBarProps {
  value: number;
  className?: string;
}

export function ProgressBar({ value, className }: ProgressBarProps) {
  const clamped = Math.max(0, Math.min(100, value));

  return (
    <div className={cn("h-2 w-full overflow-hidden rounded-full bg-[hsl(var(--secondary))]", className)}>
      <div
        className="h-full rounded-full transition-all duration-300 bg-gradient-to-r from-[hsl(var(--primary))] to-[hsl(var(--info))]"
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}
